import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function AboutPage() {
  const values = [
    {
      icon: 'ri-shield-star-fill',
      title: 'Professionnalisme',
      description: 'Nous respectons les normes les plus élevées dans tous nos services et accompagnements.'
    },
    {
      icon: 'ri-heart-fill',
      title: 'Intégrité',
      description: 'Transparence totale et honnêteté dans toutes nos interactions avec nos étudiants.'
    },
    {
      icon: 'ri-team-fill',
      title: 'Accompagnement humain',
      description: 'Un suivi personnalisé et attentif pour chaque étudiant tout au long de son parcours.'
    },
    {
      icon: 'ri-trophy-fill',
      title: 'Résultats mesurables',
      description: 'Notre succès se mesure par la réussite académique et personnelle de nos étudiants.'
    }
  ];

  const advantages = [
    {
      icon: 'ri-lightbulb-flash-fill',
      title: 'Expertise confirmée',
      description: 'Connaissance approfondie des systèmes éducatifs français, canadien et belge.'
    },
    {
      icon: 'ri-user-star-fill',
      title: 'Consultants expérimentés',
      description: 'Une équipe de professionnels qualifiés et dévoués à votre réussite.'
    },
    {
      icon: 'ri-emotion-happy-fill',
      title: 'Taux de satisfaction élevé',
      description: 'Des centaines d\'étudiants satisfaits qui ont réalisé leur rêve d\'études à l\'étranger.'
    },
    {
      icon: 'ri-customer-service-fill',
      title: 'Suivi après installation',
      description: 'Nous restons à vos côtés même après votre arrivée dans le pays d\'accueil.'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      <section className="bg-gradient-to-r from-[#003D82] to-[#0052AD] text-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-5xl font-bold mb-6">Qui sommes-nous ?</h1>
          <div className="w-24 h-1 bg-[#FF6B35] mb-6"></div>
          <p className="text-xl max-w-4xl leading-relaxed text-white/90">
            <strong>EduGlobe Campus</strong> accompagne les étudiants du Togo dans la construction de parcours d'études supérieures à l'étranger. Notre mission : offrir un service professionnel, transparent et axé sur la réussite académique et personnelle.
          </p>
        </div>
      </section>

      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <img 
                src="https://public.readdy.ai/ai/img_res/716624aceef11e5faa25a173fc3944b3.jpg"
                alt="Équipe EduGlobe Campus - Consultants en éducation internationale"
                title="Notre équipe de consultants professionnels"
                className="w-full h-[500px] object-cover rounded-2xl shadow-2xl"
              />
            </div>
            <div>
              <h2 className="text-4xl font-bold text-[#003D82] mb-6">Notre vision</h2>
              <div className="w-20 h-1 bg-[#FF6B35] mb-6"></div>
              <p className="text-lg text-gray-700 leading-relaxed mb-8">
                Devenir la référence en Afrique francophone pour l'accompagnement éducatif international, en garantissant un accompagnement sérieux, individualisé et conforme aux exigences des pays d'accueil.
              </p>
              <p className="text-lg text-gray-700 leading-relaxed">
                Nous croyons fermement que chaque étudiant mérite d'avoir accès aux meilleures opportunités éducatives internationales. Notre engagement est de rendre ce rêve accessible à tous les étudiants togolais motivés et ambitieux.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-[#003D82] mb-4">Nos valeurs</h2>
            <div className="w-24 h-1 bg-[#FF6B35] mx-auto"></div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {values.map((value, index) => (
              <div 
                key={index}
                className="bg-white rounded-xl p-8 text-center hover:shadow-xl transition-all border-2 border-transparent hover:border-[#FF6B35]"
              >
                <div className="w-20 h-20 flex items-center justify-center bg-[#FF6B35]/10 rounded-full mx-auto mb-6">
                  <i className={`${value.icon} text-4xl text-[#FF6B35]`}></i>
                </div>
                <h3 className="text-xl font-bold text-[#003D82] mb-3">{value.title}</h3>
                <p className="text-gray-600 leading-relaxed">{value.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-[#003D82] mb-4">Pourquoi nous choisir</h2>
            <div className="w-24 h-1 bg-[#FF6B35] mx-auto"></div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {advantages.map((advantage, index) => (
              <div 
                key={index}
                className="flex items-start bg-gray-50 rounded-xl p-8 hover:bg-[#FF6B35]/5 transition-all"
              >
                <div className="w-14 h-14 flex items-center justify-center bg-[#FF6B35] rounded-lg mr-6 flex-shrink-0">
                  <i className={`${advantage.icon} text-2xl text-white`}></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-[#003D82] mb-2">{advantage.title}</h3>
                  <p className="text-gray-600 leading-relaxed">{advantage.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-20 bg-[#003D82] text-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl font-bold mb-6">Rejoignez des centaines d'étudiants satisfaits</h2>
          <p className="text-xl mb-8 text-white/90">
            Faites confiance à notre expertise pour réaliser votre projet d'études à l'étranger.
          </p>
          <button
            onClick={() => document.querySelector('#vapi-widget-floating-button')?.click()}
            className="bg-[#FF6B35] text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-[#FF6B35]/90 transition-all shadow-lg whitespace-nowrap cursor-pointer inline-flex items-center"
          >
            <i className="ri-calendar-check-fill mr-3 text-2xl"></i>
            Prendre rendez-vous
          </button>
        </div>
      </section>

      <Footer />
    </div>
  );
}
